module.exports = __webpack_public_path__ + "headline.svg?53735896ad2b9bd92bc68d0dee175300";


//////////////////
// WEBPACK FOOTER
// ./static/headline.svg
// module id = 36
// module chunks = 0